import orderModule from "./orderModule"
import orderView from "./orderView.html"

orderModule.config(["editionServiceProvider", (editionServiceProvider) =>{
    editionServiceProvider.registerEdition("order", orderView, "orderController")
}])